import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserActivityStoreState {
  isIdle: boolean;
  setIsIdle: (value: boolean) => void;
  forceReloadedVersion?: string | null;
  setForceReloadedVersion: (value: string) => void;
}

export const createUserActivitySlice: StateCreator<
  UserActivityStoreState,
  [],
  [],
  UserActivityStoreState
> = (set) => ({
  // store isIdle in zustand to be able to use its value within ttl-link
  isIdle: false,
  // the same here + persistence to persist values between page reloads
  forceReloadedVersion: null,

  setForceReloadedVersion: (forceReloadedVersion) => set({ forceReloadedVersion }),
  setIsIdle: (isIdle) => set({ isIdle }),
});

const useUserActivityStore = create<UserActivityStoreState>()(
  persist(
    (...args) => ({
      ...createUserActivitySlice(...args),
    }),
    {
      name: 'pt-user-store',
      partialize: (state) => {
        // only forceReloadedAt to be persisted
        const { forceReloadedVersion } = state;
        return { forceReloadedVersion };
      },
    },
  ),
);

export default useUserActivityStore;
